<template>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <div class="card">
        <div class="card-body">
            <GChart class="chart"
                type="BarChart"
                :data="data"
                :options="options" />
        </div>
        </div>
    </div>
</template>
<script>
    import { GChart } from 'vue-google-charts'
    var options = {
      'legend': 'none',
      'backgroundColor': 'transparent',
      'is3D':true,
      hAxis: {
        minValue: 0,
        maxValue: 100,
        gridlined: {count: 10},
        title: "内容別の達成度[%]",
        textStyle:{
          fontSize: 20,
          fontName: 'Noto Sans JP'
        },
        titleTextStyle: {
          fontSize: 20,
          fontName: 'Noto Sans JP',
          italic: false
        }
      },
      vAxis: {
        textPosition : 'in',
        textStyle:{
          color: '#333',
          fontSize: 18,
          fontName: 'Noto Sans JP'
        }
      },
      chartArea:{
        left: 20,
        right: 20,
        bottom: 100
      }
    };
    export default {
        components: {
            GChart
        },
        props: [
            'data'
        ],
        data() {
            return {
                options: options,
            }
        }
    }
</script>

<style scoped>
.chart{
  min-height: 420px;
  width: 100%;
  background: rgba(0,0,0,0.0);
}

</style>